import dotenv from 'dotenv'

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './app';

dotenv.config();

ReactDOM.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,

	document.getElementById('root')
);
